import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postAuthProfile } from 'services/auth'
import posthog from 'posthog-js'
import { POST_LOGIN_PATH } from 'utilities/navigation'

export default function useSetAuthProfile(
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
) {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAuthprofilePayload) => {
            return postAuthProfile(payload)
        },
        onSuccess: (_, variables) => {
            posthog.capture('profile_completed', { is_new_user: true })
            setShowModal(false)
            navigate(POST_LOGIN_PATH)
        },
        onError: () => {
            posthog.capture('profile_completion_failed')
            toast.error('خطایی رخ داده')
        },
    })

    return { mutate }
}
